import HeadingText from '@ancon/wildcat-ui/web/orderweb/HeadingText'
import '@ancon/wildcat-ui/web/orderweb/HeadingText/HeadingText.css'

export default HeadingText
